export default function initFlipCards() {
	const flipCards = document.querySelectorAll('.flip-card');
	if (!flipCards.length) return;

	[...flipCards].forEach((flipCard) => {
		const isNoRotate = flipCard.classList.contains('flip-card-norotate');

		flipCard.classList.toggle('_flipped');

		setTimeout(() => {
			flipCard.classList.toggle('_flipped')
		}, 300);

		if (isNoRotate) return;

		flipCard.addEventListener('click', (e) => {
			const isButton = e.target.classList.contains('flip-card-button');
			const isFlipped = e.currentTarget.classList.contains('_flipped');

			if (!isFlipped) {
				[...flipCards].forEach((fC) => fC.classList.remove('_flipped'));
				e.currentTarget.classList.toggle('_flipped');
			} else if (isButton && isFlipped) {
				[...flipCards].forEach((fC) => fC.classList.remove('_flipped'));
				e.currentTarget.classList.remove('_flipped');
			}
		})
	});
}
